import { render, staticRenderFns } from "./ReviewProducts.vue?vue&type=template&id=20b13353&scoped=true&"
import script from "./ReviewProducts.vue?vue&type=script&lang=js&"
export * from "./ReviewProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b13353",
  null
  
)

export default component.exports